// AUTHOR: NANDHAKUMAR
// VERSION: 0.0.1
// LAST EDIT: NANDHAKUMAR
// DATE: 17/09/2025
// DESCRIPTION: QR REPORT PAGE ACTION
import QrReportActionTypes from './qr-report.types';

/** ***************** FETCH QR REPORT DETAILS START *********************** */
export const fetchQrReportStart = (getData: any) => ({
	type: QrReportActionTypes.FETCH_QR_REPORT_START,
	payload: getData,
});

export const fetchQrReportSuccess = (successData: any) => ({
	type: QrReportActionTypes.FETCH_QR_REPORT_SUCCESS,
	payload: successData,
});

export const fetchQrReportFailure = (failureData: any) => ({
	type: QrReportActionTypes.FETCH_QR_REPORT_FAILURE,
	payload: failureData,
});

export const fetchQrReportResponseReset = () => ({
	type: QrReportActionTypes.FETCH_QR_REPORT_RESPONSE_RESET,
});

export const fetchQrReportResponseChanged = () => ({
	type: QrReportActionTypes.FETCH_QR_REPORT_RESPONSE_CHANGED,
});
/** ***************** FETCH QR REPORT DETAILS START *********************** */
